export default __webpack_public_path__ + "static/media/front_logo.5b4914d5.svg";